import { normalize } from 'normalizr';
import { FetchStatus } from './index';
export const itemsFetchStatus = (data, fetchStatus, existingFetchStatus = {})=>{
    return data.reduce((obj, key)=>{
        const status = existingFetchStatus[key] !== FetchStatus.Loaded && fetchStatus;
        if (status) {
            obj[key] = status;
        }
        return obj;
    }, {});
};
export const filterItemsByFetchStatus = (data, fetchStatus)=>data.reduce((obj, key)=>{
        obj[key] = fetchStatus;
        return obj;
    }, {});
export const fetchStatusResult = (status)=>({
        isLoading: status === FetchStatus.Loading,
        isError: status === FetchStatus.Error,
        isPartial: status === FetchStatus.Partial,
        isSuccess: status === FetchStatus.Loaded,
        status
    });
export const dataNormalizer = (data, schema)=>{
    const dataArr = Array.isArray(data) ? data : [
        data
    ];
    return normalize(dataArr, [
        schema
    ]);
};
export const saveNormalizedData = (state, { payload })=>{
    const { data, fetchStatus } = payload;
    const notFullyLoadedKeys = Object.keys(data).filter((key)=>state.itemsFetchStatus[key] !== FetchStatus.Loaded);
    const statusResult = itemsFetchStatus(notFullyLoadedKeys, fetchStatus);
    return {
        ...state,
        items: {
            ...state.items,
            ...data
        },
        itemsFetchStatus: {
            ...state.itemsFetchStatus,
            ...statusResult
        }
    };
};
